<template>
  <div>
    <h6 class="font-weight-bold fw-400">
      {{ label }}
    </h6>
    <div class="answer-group d-flex ml-3 mb-3" :class="`${error ? 'invalid' : ''}`">
      <span 
        class="answer mr-1" 
        @click="handleChooseOption('Yes')"
        :class="{ 'answer-active': toggleValue === 'Yes' }"
      >Yes</span>
      <span 
        class="answer" 
        @click="handleChooseOption('No')"
        :class="{ 'answer-active': toggleValue === 'No' }"
      >No</span>
    </div>
    <div v-if="error" class="fs-12 text-left mb-2 mt-n3 pl-3 err-text">{{ 'Please make a selection' }}</div>
  </div>
</template>
<script>
export default {
  name: "CustomToggle",
  model: {
    prop: "toggleValue",
    event: "change",
  },
  props: {
    toggleValue: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    handleChooseOption(val) {
      this.$emit("change", val);
    },
  },
};
</script>
<style lang="scss">
.answer-group {
  .answer {
    color: #2bb673;
    font-size: 16px;
    padding: 5px 10px;
    border: 1px solid #79747e;
    border-radius: 100px;
    min-width: 132px;
    min-height: 38px;
    cursor: pointer;
    text-align: center;
  }
  .answer-active {
    color: #FFFFFF;
    background-color: #2BB673;
    border-color: #2BB673;
	}
  &.invalid {
    .answer {
      border-color: red;
    }
  }
}
</style>